import React, {useContext, useEffect, useState} from 'react';
import {Input, Space, Table} from 'antd';
import {observer} from "mobx-react";
import {ListTablePropsInterface} from "../../types";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {TableRowActions} from "../../../modules/base/action/table/table.row.actions";
import {ServicerListItem} from "../../../types/modules/servicer/modules";
import {useParams} from "react-router-dom";
import {HelperService} from "../../../service/helper.service";
import {BaseModule} from "../../../types/modules";
import {TablePaginationConfig} from "antd/es/table";
import {FilterValue} from "antd/es/table/interface";
import {StoreContext} from "../../../store.context";
const { Search } = Input;

export const ListTable: React.FC<ListTablePropsInterface> = observer((props) => {
    const { id } : { id: any } = useParams() as any;
    const { appStore: {
        translate
    } } = useContext(StoreContext);

    const [ list, setList ] = useState<BaseModule[]>([]);
    const [ loading, setLoading ] = useState<boolean>();
    const [ searchText, setSearchText ] = useState<string>();
    const [ tablePaginationData, setTablePaginationData ] =
            useState<{current?: number, pageSize?: number, field?: string, order?: string, searchText?: string}>({
                current: 1, pageSize: 10
            });

    const load = () => {
        setLoading(true);

        props.dataLoader({
            id,
            pageSize: tablePaginationData?.pageSize ?? 10,
            current: tablePaginationData?.current ?? 1,
            checkRoutes: props.actions.map(action => HelperService.generateURL(props.module, action)),
            searchText,
        })
                .then(( response) => {
                    setList(response.data);
                    setLoading(false);
                });
    }

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        load();
    }, [tablePaginationData?.current, tablePaginationData?.pageSize, tablePaginationData?.field, searchText]);

    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: any
    ) => {
        setTablePaginationData({
            current: pagination.current,
            pageSize: pagination.pageSize,
            field: sorter.order ? sorter.field : null,
            order: sorter.order ? sorter.order : null
        });
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
       const value = e.target.value;
        handleSearch(value);
    };

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <>
                <Search
                    placeholder={ translate('global.search', {}, TranslationDomainEnum.MESSAGES) }
                    style={{ margin: 16, marginBottom: 0, maxWidth: '300px' }}
                    onChange={handleChange}
                />
            </>

            <Table dataSource={list as BaseModule[]}
                   size={`small`}
                   onChange={handleTableChange}
                   loading={loading}
                   rowKey={`id`}
                   pagination={{
                       current: tablePaginationData?.current,
                       pageSize: tablePaginationData?.pageSize,
                       total: list.length,
                       position: ['bottomCenter'],
                       showSizeChanger: true
                    }}
            >
                { props.headers.map(header => {
                    if (header === 'active') {
                        return (
                            <Table.Column<ServicerListItem>
                                title={<Translate message={`servicer.fields.status`}
                                                  domain={TranslationDomainEnum.COMPANY_ADMINISTRATION}/>}
                                dataIndex={header}
                                key={header}
                                sorter={false}
                                render={(_) => (
                                    <Translate message={_ ? "global.active" : "global.not_active"}/>
                                )}
                            />
                        )
                    }

                    return (
                        <Table.Column<BaseModule>
                            title={<Translate message={`servicer.fields.${header}`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />}
                            dataIndex={header}
                            key={header}
                            sorter={header !== 'addressString'}
                        />
                    )
                })}

                <Table.Column<BaseModule>
                        title={`actions`}
                        dataIndex={`actions`}
                        key={`actions`}
                        align={`right`}
                        render={(_, record) => <TableRowActions module={ props.module } record={ record } actions={ props.actions } />}
                />
            </Table>
        </Space>
    )
})